import { render } from "./CustomAntiRedManagement.vue?vue&type=template&id=0791350f&scoped=true"
import script from "./CustomAntiRedManagement.vue?vue&type=script&lang=js"
export * from "./CustomAntiRedManagement.vue?vue&type=script&lang=js"

import "./CustomAntiRedManagement.vue?vue&type=style&index=0&id=0791350f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_8601aa9edf40feba5c1f16c508af6bdf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0791350f"]])

export default __exports__